module.exports = __webpack_public_path__ + "img/fog.66fd3304.svg";